export const SHOW_COMMENT_REQUEST = 'SHOW_COMMENT_REQUEST';
export const SHOW_COMMENT_SUCCESS = 'SHOW_COMMENT_SUCCESS';
export const SHOW_COMMENT_FAIL    = 'SHOW_COMMENT_FAIL';
